import type { InputCityProperties } from ".";
import { useDeferredValue, useMemo, useRef, useEffect } from "react";
import { AirportIndex } from "@jetblue/fuzzy-search";

export const useFilteredItems = (
  inputValue: string,
  items: InputCityProperties["items"] = [],
) => {
  const deferredInputValue = useDeferredValue(inputValue);
  const indexReference = useRef<AirportIndex>(null);
  useEffect(() => {
    indexReference.current ??= new AirportIndex();
    indexReference.current.set_items(items);
  }, [items]);

  return useMemo(() => {
    const searchString = deferredInputValue.toLowerCase();
    return (
      searchString && indexReference.current
        ? indexReference.current
            .search(searchString)
            .map((match) => match.candidate)
        : items
    ).flatMap(
      (airport) =>
        [
          airport,
          ...(airport.cc ?? []).map((a) => ({ ...a, indent: true })),
        ] as (typeof airport & { indent?: boolean })[],
    );
  }, [items, deferredInputValue]);
};
